import {ChipProps} from "@mui/material";
import React from "react";
import {TrackingRecord} from "../../../../shared/models/order/trackingRecord.model";
import BarekamChip from "../../../../components/chip/barekamChip";

export const StatusChip = (props: StatusChipProps) => {
    const {trackingRecord} = props;

    if (trackingRecord[0]) {
        return (
            <BarekamChip messageKey={trackingRecord[0].state.name}
                         statusId={3}
                         chipSize={'s'}/>
        )
    } else {
        return <></>
    }
}

interface StatusChipProps extends ChipProps{
    trackingRecord: TrackingRecord[];
}
